import type { Customer } from './types';

// Mint-Customers-iPad / -Phone: danh bạ dạng thẻ. Hai board này có bảng EXT riêng (tỉnh · hạng) lệch vài khách so với board máy bàn,
// nên hiển thị lấy theo EXT của board gọn; dữ liệu gốc (fixtures) giữ nguyên cho bảng máy bàn.
const EXT: Record<string, { prov: string; cls: number }> = {
  'RUITONGVN-SC': { prov: 'Bình Dương', cls: 2 },
  GREENBUD: { prov: 'TP Hồ Chí Minh', cls: 1 },
  NAMMY: { prov: 'TP Hồ Chí Minh', cls: 3 },
  SAVITA: { prov: 'TP Hồ Chí Minh', cls: 1 },
  PHUCUONGEXIM: { prov: 'TP Hồ Chí Minh', cls: 5 },
  QUEKYCORP: { prov: 'Đồng Nai', cls: 2 },
  TAMNGOC: { prov: 'Long An', cls: 1 },
  ARRIVE: { prov: 'Bình Dương', cls: 4 },
  NDP: { prov: 'TP Hồ Chí Minh', cls: 3 },
  COCOGROUP: { prov: 'Tây Ninh', cls: 4 },
  THANHHAO: { prov: '—', cls: 4 },
  EMDEES: { prov: '—', cls: 5 },
};

export interface CompactRow {
  c: Customer;
  prov: string;
  cls: number;
}

export const compactRow = (c: Customer): CompactRow => ({ c, prov: EXT[c.id]?.prov ?? c.province, cls: EXT[c.id]?.cls ?? c.tier });

export type QuickKey = 'mine' | 'top' | 'miss' | 'per';
/** Chip lọc nhanh của board (QF): Của tôi = sale đang đăng nhập (DAVID trong dữ liệu mẫu). */
export const QUICK: readonly { key: QuickKey; label: string; test: (r: CompactRow) => boolean }[] = [
  { key: 'mine', label: 'Của tôi', test: (r) => r.c.sale === 'DAVID' },
  { key: 'top', label: 'Hạng 1–2', test: (r) => r.cls <= 2 },
  { key: 'miss', label: 'Thiếu liên hệ', test: (r) => r.c.contactCount === 0 },
  { key: 'per', label: 'Cá nhân', test: (r) => r.c.kind === 'Cá nhân' },
];

export const ALL_PROV = 'Tất cả tỉnh';
export const PROVINCES = [ALL_PROV, 'TP Hồ Chí Minh', 'Bình Dương', 'Đồng Nai', 'Long An', 'Tây Ninh'] as const;

export function filterCompact(rows: readonly CompactRow[], quick: ReadonlySet<QuickKey>, prov: string): CompactRow[] {
  return rows.filter((r) => QUICK.every((q) => !quick.has(q.key) || q.test(r)) && (prov === ALL_PROV || r.prov === prov));
}

/** Nhãn cờ ở dòng khách: KHÔNG số tiền (luật tiền). Giữ DO khi vượt hạn mức (board: "Vượt hạn" + khoá DO). */
export function flagOf(c: Customer): { text: string; over: boolean } | null {
  const over = c.credit.limit > 0 && c.credit.used > c.credit.limit;
  if (over) return { text: 'Vượt hạn', over: true };
  return c.credit.overdue > 0 ? { text: 'Quá hạn', over: false } : null;
}

/** Board gọn: tab "Tiềm năng" và "Đối tác" là dữ liệu riêng của board, chưa có trong CRM — chỉ đếm. */
export const LEADS_IPAD = 8;
export const LEADS_PHONE = 6;
export const PARTNERS_IPAD = 6;
export const PHONE_LIMIT = 10;
